import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types';
import Tr from "translations/Translations";
import Dialog from "components/Dialog";
import Loading from "components/Loading";
import Typography from "components/Typography";
import {makeStyles} from "@material-ui/styles";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import EzdpuwList from "./EzdpuwList";
import EzdpuwService from "services/EzdpuwService";

const useStyle = makeStyles(theme => ({
    root: {},
    rotate: {
        transform: 'rotate(90deg)'
    },
    breadcrumbText: {
        marginRight: theme.spacing(2)
    },
    checkbox: {
        padding: "0 11px"
    },
    selDocuments: {
        marginRight: 200
    },
    dialogContent: {
        minHeight: 500
    },
    loading: {
        position: 'absolute',
        width: 900,
        height: 50
    },
    titleIcon: {
        position: 'absolute',
        left: theme.spacing(2),
        color: theme.palette.primary.main,
    }
}))


function EzdpuwExplorer(
    {
        demandId,
        onClose,
        handleSubmit
    }) {
    const classes = useStyle();
    const [filesAndFolders, setFilesAndFolders] = useState(null);
    const [selectedFileMap, setSelectedFilesMap] = useState(new Map());
    const [working, setWorking] = useState(true);
    const [workingCase, setWorkingCase] = useState(null);

    useEffect(() => {
        EzdpuwService.getCases(demandId).then((resp) => {
            setFilesAndFolders(resp);
        }).then(() => setWorking(false)).catch(onClose);
        // eslint-disable-next-line
    }, [demandId])


    const toggleSelectFile = (file) => {
        const newMap = new Map(selectedFileMap);
        if (newMap.has(file.id)) {
            newMap.delete(file.id);
            setSelectedFilesMap(newMap);
        } else {
            const {attachments, ...others} = file;
            newMap.set(file.id, others)
            setSelectedFilesMap(newMap);
        }
    }
    const toggleExpandCase = (file) => {
        if (working || workingCase)
            return;

        if ((file.attachments !== null)) {
            setFilesAndFolders(filesAndFolders.map(x => x.id === file.id ? {...x, attachments: null} : x))
        } else {
            setWorkingCase(file.id);
            EzdpuwService.getDocuments(demandId, file.id).then((resp) => {
                setFilesAndFolders(filesAndFolders.map(x => x.id === file.id ? {...x, attachments: resp} : x));
            }).finally(() => {
                setWorkingCase(null);
            })
        }
    }

    const getButtons = () => {
        const buttons = [];
        buttons.push(createButton(Tr('cancel'), onClose, 'outlined', working || !!workingCase));
        buttons.push(createButton(Tr('add'), () => handleSubmit(Array.from(selectedFileMap).map(([key, value]) => value)), undefined, working || !!workingCase || selectedFileMap.size === 0));
        return buttons;
    }

    return (
        <Dialog
            open
            title={
                <div>
                    {Tr("int_explorer_dialog_title_x", {x: "ezdpuw"}, true)}
                </div>}
            titleCentered
            maxWidth="md"
            onClose={onClose}
            contentClassName={classes.dialogContent}
            dialogActions={
                <>
                    <MultiButton
                        buttons={getButtons()}
                        before={<Typography className={classes.selDocuments}>{`${Tr('documents_selected')}: ${selectedFileMap.size}`} </Typography>}
                    />
                </>
            }
        >

            {working && <Loading className={classes.loading}/>}
            {!!filesAndFolders && <>
                <EzdpuwList documents={filesAndFolders} selectedFileMap={selectedFileMap} toggleSelectFile={toggleSelectFile}
                            toggleExpandCase={toggleExpandCase} workingCase={workingCase}/>
            </>}


        </Dialog>
    )
}

EzdpuwExplorer.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onClose: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired
}

export default EzdpuwExplorer;